<template>
    <div class="row">
        <div class="grid-1 w-full dashboard">
            <div class="card col-span-1">
                <div class="card-header">
                    <svg-icon icon="eventos" class="icon" />
                    <h3>Eventos</h3>
                </div>
                <div class="card-body">
                    {{ numEventos }}
                </div>
                <div class="card-footer p-2 border-t-2 border-light-gray text-right">
                    <router-link to="/sistema/eventos/novo-evento" class="text-black uppercase text-xs font-bold">
                        Novo evento
                    </router-link>
                </div>
            </div>
            <div class="card col-span-1">
                <div class="card-header">
                    <svg-icon icon="newsletter"  class="icon" />
                    <h3>Contatos</h3>
                </div>
                <div class="card-body">
                    {{ numContatos }}
                </div>
                <div class="card-footer p-2 border-t-2 border-light-gray text-right">
                    <router-link to="/sistema/eventos/novo-evento" class="text-black uppercase text-xs font-bold">
                        Novo inscrito
                    </router-link>
                </div>
            </div>
            <div class="card col-span-1">
                <div class="card-header">
                    <svg-icon icon="sindicatos"  class="icon" />
                    <h3>Sindicatos</h3>
                </div>
                <div class="card-body">
                    {{ numSindicatos }}
                </div>
                <div class="card-footer p-2 border-t-2 border-light-gray text-right">
                    <router-link to="/sistema/sindicatos/novo-sindicato" class="text-black uppercase text-xs font-bold">
                        Novo sindicato
                    </router-link>
                </div>
            </div>
            <div class="card col-span-1">
                <div class="card-header">
                    <svg-icon icon="noticias"  class="icon" />
                    <h3>Notícias</h3>
                </div>
                <div class="card-body">
                    {{ numNoticias }}
                </div>
                <div class="card-footer p-2 border-t-2 border-light-gray text-right">
                    <router-link to="/sistema/noticias/nova-noticia" class="text-black uppercase text-xs font-bold">
                        Nova Notícia
                    </router-link>
                </div>
            </div>
            <div class="card col-span-1">
                <div class="card-header">
                    <svg-icon icon="star"  class="icon" />
                    <h3>Palavra do presidente</h3>
                </div>
                <div class="card-body">
                    {{ numPlPresidente }}
                </div>
                <div class="card-footer p-2 border-t-2 border-light-gray text-right">
                    <router-link to="/sistema/noticias/nova-noticia" class="text-black uppercase text-xs font-bold">
                        Nova Palavra do Presidente
                    </router-link>
                </div>
            </div>
            <div class="card col-span-1">
                <div class="card-header" >
                    <svg-icon icon="pencil"  class="icon" />
                    <h3>Comentário do diretor</h3>
                </div>
                <div class="card-body">
                    {{ numComDiretor }}
                </div>
                <div class="card-footer p-2 border-t-2 border-light-gray text-right">
                    <router-link to="/sistema/noticias/nova-noticia" class="text-black uppercase text-xs font-bold">
                        Novo Comentário do Diretor
                    </router-link>
                </div>
            </div>
            <div class="card col-span-1 h-48">
                <div class="card-header">
                    <svg-icon icon="publish"  class="icon" />
                    <h3>Publicações</h3>
                </div>
                <div class="card-body">
                    {{ numPublicacoes }}
                </div>
                <div class="card-footer p-2 border-t-2 border-light-gray text-right">
                    <router-link to="/sistema/publicacoes/nova-publicacao" class="text-black uppercase text-xs font-bold">
                        Nova Publicação
                    </router-link>
                </div>
            </div>
            <div class="card col-span-1">
                <div class="card-header">
                    <svg-icon icon="eventos"  class="icon" />
                    <h3>Próximo evento</h3>
                </div>
                <div class="card-list">
                    <div class="field">
                        Nome do Evento
                        <p class="uppercase">{{ proxEvento.nome }}</p>
                    </div>
                    <div class="field">
                        Cidade do Evento
                        <p>{{ proxEvento.cidade }}</p>
                    </div>
                    <div class="field">
                        Local do Evento
                        <p class="uppercase">{{ proxEvento.local }}</p>
                    </div>
                    <div class="field">
                        Inscritos para Evento
                        <p>{{ inscritosProx }}</p>
                    </div>
                    <div class="field">
                        Horário do Evento
                        <p>{{ formateHora(proxEvento.hora_inicio) }} - {{ formateHora(proxEvento.hora_termino) }}</p>
                    </div>
                </div>
            </div>
            <div class="card col-span-1">
                <div class="card-header">
                    <svg-icon icon="eventos" />
                    <h3>Último evento</h3>
                </div>
                <div class="card-list">
                    <div class="field">
                        Nome do Evento
                        <p class="uppercase">{{ ultimEvento.nome }}</p>
                    </div>
                    <div class="field">
                        Cidade do Evento
                        <p>{{ ultimEvento.cidade }}</p>
                    </div>
                    <div class="field">
                        Local do Evento
                        <p class="uppercase">{{ ultimEvento.local }}</p>
                    </div>
                    <div class="field">
                        Inscritos para Evento
                        <p>{{ inscritosUlt }}</p>
                    </div>
                    <div class="field">
                        Horário do Evento
                        <p>{{ formateHora(ultimEvento.hora_inicio) }} - {{ formateHora(ultimEvento.hora_termino) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "dashboard",
    data() {
        return {
            numEventos: 0,
            numContatos: 0,
            numSindicatos: 0,
            numNoticias: 0,
            numPlPresidente: 0,
            numComDiretor: 0,
            numPublicacoes: 0,
            inscritosProx: 0,
            inscritosUlt: 0,
            ultimEvento: {},
            proxEvento: {},

        }
    },
    methods: {
        /** Método que retorna quantidade
         * de eventos cadastrados
         * **/
        buscarQtdEventos() {
            this.axios('todos-eventos').then(res => {
                this.numEventos = res.data.eventos
                this.buscarQtdContatos()
            }).catch(error => {
                console.error(error)
            })
        },

        /** Método que retorna quantidade
         * de contatos cadastrados
         * **/
        buscarQtdContatos() {
            this.axios('todos-inscritos').then(res => {
                this.numContatos = res.data.inscritos
                this.buscarQtdSindicatos()
            }).catch(error => {
                console.error(error)
            })
        },

        /** Método que retorna quantidade
         * de sindicatos cadastrados
         * **/
        buscarQtdSindicatos() {
            this.axios('todos-sindicatos').then(res => {
                this.numSindicatos = res.data.sindicatos
                this.buscarNoticias()
            }).catch(error => {
                console.error(error)
            })
        },

        /** Método que retorna quantidade
         * de notícias cadastradas
         * **/
        buscarNoticias() {
            this.axios('todas-ugt-noticias').then(res => {
                this.numNoticias = res.data.ugtnoticias
                this.buscarPalavraDoPresidente()
            }).catch(error => {
                console.error(error)
            })
        },

        buscarPalavraDoPresidente() {
            this.axios('todas-presidente').then(res=> {
                this.numPlPresidente = res.data.presidente
                this.buscarDiretor()
            }).catch(error => {
                console.error(error)
            })
        },

        buscarDiretor() {
            this.axios('todas-diretor').then(res=> {
                this.numComDiretor = res.data.diretor
                this.buscarPublicacoes()
            }).catch(error => {
                console.error(error)
            })
        },

        /** Método que retorna quantidade
         * de publicações cadastradas
         * **/
        buscarPublicacoes() {
            this.axios('todas-publicacoes').then(res => {
                this.numPublicacoes = res.data.publicacoes
                this.buscarUltimoEvento()
            }).catch(error => {
                console.error(error)
            })
        },

        buscarUltimoEvento() {
            const today = new Date();
            const mes = today.getMonth() + 1
            const date = `${today.getFullYear()}-${mes}-${today.getDate()}`
            this.axios(`ultimo-evento/${date}`).then(res => {
                this.ultimEvento = res.data.ultimo ?  res.data.ultimo : {}
                this.proxEvento = res.data.proximo ? res.data.proximo : {}
            }).catch(error => {
                console.error(error)
            })
        },

        formateHora(value) {
            if(value === undefined  || value === null || value === "") {
                return ""
            } else {
                const hora  = value.split(":")
                return `${hora[0]}:${hora[1]}`
            }

        },

        controleDeExcecao() {
            if(this.proxEvento.nome === undefined) {
                this.proxEvento.nome = ''
                this.proxEvento.cidade = ''
                this.proxEvento.local = ''
                this.inscritosProx = ''
                this.proxEvento.hora_inicio = ''
                this.proxEvento.hora_termino = ''
            }

            if(this.ultimEvento.nome === undefined) {
                this.ultimEvento.nome = '-'
                this.ultimEvento.cidade = '-'
                this.ultimEvento.local = '-'
                this.inscritosUlt = ''
                this.ultimEvento.hora_inicio = ''
                this.proxEvento.hora_termino = ''
            }
        }
    },

    created() {
        this.buscarQtdEventos()
        this.controleDeExcecao()
    }
}
</script>

<style lang="scss" scoped>
    .dashboard {
        @media(min-width: 768px) {
            @apply grid-cols-3;
        }

        .card {
            @apply p-0;
        }

        .card:hover {
            svg {
                @apply text-red-600;
            }

            h3 {
                @apply text-red-600 font-bold shadow-inner;

            }
        }

        .card-header {
            height: 50px;
            @apply py-0 mb-0 px-1 flex items-center justify-between bg-dark-gray text-white uppercase;
            @media(min-width: 768px) {
                @apply px-6;
            }
            svg {
                @apply text-3xl;

            }
        }

        .card-body {
            @apply text-center text-4xl;
        }

        .card-list {
            @apply py-2 row-span-2;
            .field {
                @apply border-b-2 border-light-gray py-1 px-2 font-medium flex justify-between text-sm;
                p {
                    @apply font-normal text-sm text-right;
                }
            }
            .field:last-child {
                @apply border-b-0;
            }
        }

        h3{
            @apply text-right;
            font-size: 16px;
        }
    }
</style>
